export const tableConfig = {
  tableClass: 'table table-bordered table-striped table-hover',
  ascendingIcon: 'fas fa-fw fa-sort-up',
  descendingIcon: 'fas fa-fw fa-sort-down',
  sortableIcon: 'fas fa-fw fa-sort',
  renderIcon(classes) {
    return `<i class="${classes.join(' ')}"></i>`;
  }
};

export const paginationConfig = {
  wrapperClass: 'pagination',
  activeClass: 'active',
  disabledClass: 'disabled',
  pageClass: 'page',
  linkClass: 'link',
  icons: {
    first: 'fa fa-angle-double-left',
    prev: 'fa fa-angle-left',
    next: 'fa fa-angle-right',
    last: 'fa fa-angle-double-right'
  }
};

export const iconsConfig = {
  first: 'glyphicon glyphicon-step-backward',
  prev: 'glyphicon glyphicon-chevron-left',
  next: 'glyphicon glyphicon-chevron-right',
  last: 'glyphicon glyphicon-step-forward'
};
